import React from "react";
import "./logo.css";

const Logo = () => {
  return (
    <div className="text-white fill-current  logo__constants logo-wrap">
      <svg width="140px" height="60px">
        <path
          className="letter s"
          d="M 0 0 L 15 0 L 15 4 L 4 4 L 4 8 L 15 8 L 15 20 L 0 20 L 0 16 L 11 16 L 11 12 L 0 12 L 0 0 Z"
        />

        <path
          className="letter h"
          d="M 20 0 L 20 20 L 24 20 L 24 12 L 32 12 L 32 20 L 32 20 L 36 20 L 36 0 L 36 0 L 32 0 L 32 8 L 24 8 L 24 0 L 20 0 Z"
        />

        <path
          className="letter i-1"
          d="M 41 20 L 41 0 L 45 0 L 45 20 L 41 20 Z"
        />

        <path
          className="letter b"
          d="M 50 20 L 50 0 L 60 0 C 67 0 67 10 62 10 C 67 10 67 20 60 20 Z 
                    M 60 8 C 62 8 62 4 60 4 L 54 4 L 54 8 L 60 8 Z
                    M 60 16 C 62 16 62 12 60 12 L 54 12 L 54 16 L 60 16 Z"
        />

        <path
          className="letter i-2"
          d="M 70 20 L 70 0 L 74 0 L 74 20 Z "
        />

        <path
          className="letter n"
          d="M 79 20 L 79 0 L 83 0 L 90 12 L 90 0 L 94 0 L 94 20 L 90 20 L 83 8 L 83 20 L 83 20    L 79 20 Z"
        />
      </svg>
    </div>
  );
};

export default Logo;
